var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08163 1.23242L1.01497 4.16576V9.29909C1.01497 15.2098 0.281633 18.8324 9.08163 21.7658C17.8816 18.8324 17.1483 15.2098 17.1483 9.29909V4.16576L9.08163 1.23242Z",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08159 10.0328C10.2966 10.0328 11.2816 9.04784 11.2816 7.83281C11.2816 6.61779 10.2966 5.63281 9.08159 5.63281C7.86657 5.63281 6.88159 6.61779 6.88159 7.83281C6.88159 9.04784 7.86657 10.0328 9.08159 10.0328Z",
    strokeWidth: 1.41431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7484 15.8982H5.41504C5.41504 14.2848 6.72037 12.9648 8.34837 12.9648H9.81504C11.4284 12.9648 12.7484 14.2848 12.7484 15.8982Z",
    strokeWidth: 1.41431,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2de4fa8979c3345fd302ca235c6e4cc7.svg";
export { ForwardRef as ReactComponent };